// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { CartProvider } from './context/CartContext'; 

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop'; // <-- Importar ScrollToTop
import HomePage from './pages/HomePage';
import CatalogoPage from './pages/CatalogoPage';
import ProductDetailPage from './pages/ProductDetailPage';
import DomicilioPage from './pages/DomicilioPage';
import CarritoPage from './pages/CarritoPage';
import ContactoPage from './pages/ContactoPage'; 
import { Toaster } from 'react-hot-toast'; 

function App() {
  return (
    // 2. ENVUELVE TODO CON EL CARTPROVIDER
    <CartProvider>
      <Router>
        <ScrollToTop /> {/* <-- Agregar ScrollToTop aquí */}
          <Toaster // <-- 2. AÑADE EL COMPONENTE AQUÍ
          position="top-center" // Podemos configurar la posición
          toastOptions={{
            duration: 3000, // Duración de 3 segundos
          }}
        />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/catalogo" element={<CatalogoPage />} />
            <Route path="/producto/:id" element={<ProductDetailPage />} /> {/* <-- Nueva ruta */}
            <Route path="/domicilio" element={<DomicilioPage />} />
            <Route path="/carrito" element={<CarritoPage />} /> {/* <-- 3. Añade la ruta del carrito */}
            <Route path="/contacto" element={<ContactoPage />} />
            {/* Puedes añadir más rutas aquí */}
            {/* ... otras rutas ... */}
          </Routes>
        </main>
        <Footer />
      </Router>
    </CartProvider>
  );
}


export default App;